import { ScreenBase } from "@frui.ts/screens/dist";
import { action, computed } from "mobx";
import type LocalizationService from "../services/localizationService";
import type SecurityService from "../services/securityService";

export default class LoginViewModel extends ScreenBase {
  constructor(private localizationService: LocalizationService, private securityService: SecurityService) {
    super();
  }

  @computed
  get loginInProgress() {
    return this.securityService.loginInProgress;
  }

  async onInitialize() {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");

    if (code) {
      await this.securityService.completeLogin();
      window.history.replaceState({}, "", `${window.location.pathname}`);
    } else {
      this.checkSession();
    }
  }

  @action.bound
  onCzechPointLogin() {
    this.securityService.login("idp:CzechPoint");
  }

  @action.bound
  onCendisLdapLogin() {
    this.securityService.login("idp:CendisLdap");
  }

  @action.bound
  onInternalLogin() {
    this.securityService.login();
  }

  private checkSession() {
    return this.securityService.isLogged;
  }

  translateGeneral(code: string, size?: number) {
    return this.localizationService.translateGeneral(code, size);
  }
}
